import React from "react";
import { MdArrowForwardIos } from "react-icons/md";

const AssessmentCodeCard = ({ title, description, count, imageUrl, onViewAll }) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden flex flex-col justify-between">
      <div>
        {/* Card Image Header */}
        <div className="h-64 w-full overflow-hidden bg-gray-100">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover" />
        </div>

        <div className="p-6">
          <h3 className="text-xl font-medium text-gray-900 mb-3">{title}</h3>
          <p className="text-gray-500 text-sm leading-relaxed mb-6">{description}</p>
          <div className="bg-indigo-50 border-2 border-gray-300 rounded-xl p-4 flex items-center justify-between mb-4">
            <div>
              <p className="text-lg text-gray-900 capitalize mb-1">Available Codes</p>
              <p className="text-3xl font-semibold text-gray-900">{count}</p>
            </div>
            <div className="w-16 h-16 rounded-lg bg-indigo-200 text-indigo-600 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 001 1.5 2 2 0 010 3.5 2 2 0 00-2 2v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 00-2-2 2 2 0 010-3.5 2 2 0 002-1.5V7a2 2 0 00-2-2H5z" /></svg>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 pb-6">
        <button onClick={onViewAll} className="w-full py-2.5 px-4 rounded-md border-2 border-gray-300 hover:border-blue-600 text-indigo-600 hover:bg-indigo-50 font-medium text-basse flex items-center justify-center gap-2 transition-colors duration-200">
          <span>View All Codes</span>
          <MdArrowForwardIos size={20} />
        </button>
      </div>
    </div>
  );
};

export default AssessmentCodeCard;